var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ranking-container" }, [
    _vm._m(0),
    _c("div", { staticClass: "ranking-body" }, [
      _c(
        "div",
        { staticClass: "list-wrap dz-scroll-y" },
        _vm._l(_vm.List, function (item, index) {
          return _c("div", { key: index, staticClass: "list" }, [
            _c("p", [
              _c("span", { staticClass: "ranking-num" }, [
                _vm._v(_vm._s(index + 1)),
              ]),
              _c("span", { staticClass: "ranking-name" }, [
                _vm._v(_vm._s(item.Name)),
              ]),
              _c("span", { staticClass: "ranking-trade-money" }, [
                _vm._v(_vm._s(item.TotalAmount)),
              ]),
              _c(
                "span",
                {
                  staticClass: "a_href",
                  on: {
                    click: function ($event) {
                      return _vm.goCustmerDetail(item.CustomerId)
                    },
                  },
                },
                [_vm._v("交易记录")]
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ranking-header" }, [
      _c("div", { staticClass: "ranking-title" }, [
        _vm._v("本月客户交易额排行"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }